import { createBrowserHistory } from 'history';
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from  'redux-saga';

import { persistStore } from 'redux-persist';
import RootReducer from './rootReducer';
import RootSaga from './rootSaga';
import persistReducer from 'redux-persist/es/persistReducer';
import storage from 'redux-persist/lib/storage';
import { getPersistConfig } from 'redux-deep-persist';

export const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();

const persistConfig = getPersistConfig({
  key: 'reading',
  storage:storage,
  whitelist:['giftCardReducer.cart'],
  rootReducer: RootReducer
})
const persistedReducer = persistReducer(persistConfig, RootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    devTools: true,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
});
  
sagaMiddleware.run(RootSaga);

export const persistor = persistStore(store);

export type RootState = ReturnType <typeof store.getState>;



